import { __decorate, __metadata } from "tslib";
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { cardStyle } from './card.style';
let CardElement = class CardElement extends LitElement {
    constructor() {
        super(...arguments);
        this.overlayView = false;
        this.showShadow = false;
    }
    static { this.tagName = 'inch-card'; }
    static { this.styles = cardStyle; }
    render() {
        return html `
      <slot name="close-overlay"></slot>
      <slot name="header"></slot>
      <div class="card-content">
        <slot></slot>
      </div>
    `;
    }
    firstUpdated() {
        if (this.overlayView && !this.classList.contains('overlay')) {
            this.classList.add('overlay');
        }
        if (this.showShadow && !this.classList.contains('shadow')) {
            this.classList.add('shadow');
        }
    }
};
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], CardElement.prototype, "overlayView", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Object)
], CardElement.prototype, "showShadow", void 0);
CardElement = __decorate([
    customElement(CardElement.tagName)
], CardElement);
export { CardElement };
//# sourceMappingURL=card.element.js.map